import { render, staticRenderFns } from "./PopupLeagueTerms.vue?vue&type=template&id=de5cffbc&"
import script from "./PopupLeagueTerms.vue?vue&type=script&lang=js&"
export * from "./PopupLeagueTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports